import { Helmet } from 'react-helmet-async'
import { Hero } from '@/components/sections/Hero'
import { About } from '@/components/sections/About'
import { Capabilities } from '@/components/sections/Capabilities'
import { Services } from '@/components/sections/Services'
import { Team } from '@/components/sections/Team'
import { ContactCTA } from '@/components/sections/ContactCTA'

export function Home() {
  return (
    <>
      <Helmet>
        <title>i3 Solutions — Tecnologia que transforma negócios</title>
        <link rel="canonical" href="https://i3solutions.tech/" />
      </Helmet>
      <Hero />
      <About />
      <Capabilities />
      <Services />
      <Team />
      <ContactCTA />
    </>
  )
}
